<span class="text-left fw-700 color-red d-inline-block" *ngIf="!isComplete">
    {{ text }}
</span>